// pages/Landing.jsx
import {
  Box,
  Flex,
  Heading,
  Text,
  Button,
  SimpleGrid,
  Icon,
  Stack,
  useColorModeValue,
} from "@chakra-ui/react";
import { Shield, Zap, Gift, Lock } from "lucide-react";
import { Link } from "react-router-dom";

const Landing = () => {
  const bgHero = useColorModeValue("gray.50", "gray.900");
  const cardBg = useColorModeValue("white", "gray.700");

  return (
    <Box>
      {/* Hero Section */}
      <Box bg={bgHero} py={20} textAlign="center">
        <Heading
          as="h1"
          size="2xl"
          fontWeight="extrabold"
          color="indigo.700"
          mb={4}
        >
          Converti XML in PDF in modo sicuro
        </Heading>
        <Text fontSize="lg" color="gray.600" mb={6}>
          La soluzione veloce e affidabile per professionisti e aziende.
        </Text>
        <Button
          as={Link}
          to="/login"
          size="lg"
          colorScheme="indigo"
          px={8}
          py={6}
        >
          Inizia Gratis
        </Button>
      </Box>

      {/* Perché scegliere noi */}
      <Box py={16} px={6} maxW="6xl" mx="auto">
        <Heading as="h2" size="xl" textAlign="center" mb={12} color="indigo.700">
          Perché scegliere noi
        </Heading>
        <SimpleGrid columns={{ base: 1, md: 3 }} spacing={8}>
          <Box bg={cardBg} p={6} borderRadius="xl" shadow="lg" textAlign="center">
            <Icon as={Shield} w={10} h={10} color="green.500" mb={4} />
            <Text fontWeight="bold" fontSize="lg">Sicurezza</Text>
            <Text fontSize="sm" color="gray.500">
              Tutti i file sono protetti con crittografia e accesso sicuro.
            </Text>
          </Box>
          <Box bg={cardBg} p={6} borderRadius="xl" shadow="lg" textAlign="center">
            <Icon as={Lock} w={10} h={10} color="blue.500" mb={4} />
            <Text fontWeight="bold" fontSize="lg">Privacy</Text>
            <Text fontSize="sm" color="gray.500">
              Nessuna pubblicità, nessuna condivisione dei tuoi dati.
            </Text>
          </Box>
          <Box bg={cardBg} p={6} borderRadius="xl" shadow="lg" textAlign="center">
            <Icon as={Gift} w={10} h={10} color="purple.500" mb={4} />
            <Text fontWeight="bold" fontSize="lg">100 crediti di benvenuto</Text>
            <Text fontSize="sm" color="gray.500">
              Prova subito il servizio senza costi iniziali.
            </Text>
          </Box>
        </SimpleGrid>
      </Box>

      {/* Pricing Preview */}
      <Box py={16} px={6} bg={useColorModeValue("gray.100", "gray.800")}>
        <Heading as="h2" size="xl" textAlign="center" mb={12} color="indigo.700">
          I nostri piani
        </Heading>
        <SimpleGrid columns={{ base: 1, md: 3 }} spacing={8} maxW="6xl" mx="auto">
          <Box bg={cardBg} p={8} borderRadius="xl" shadow="lg" textAlign="center">
            <Text fontWeight="bold" fontSize="lg" mb={2}>One Shot</Text>
            <Text fontSize="sm" color="gray.500" mb={4}>Pacchetti di crediti singoli</Text>
            <Text fontSize="2xl" fontWeight="extrabold" color="indigo.600">€9,99</Text>
            <Button mt={6} colorScheme="indigo" as={Link} to="/login">Acquista</Button>
          </Box>
          <Box bg={cardBg} p={8} borderRadius="xl" shadow="lg" textAlign="center">
            <Text fontWeight="bold" fontSize="lg" mb={2}>Mensile</Text>
            <Text fontSize="sm" color="gray.500" mb={4}>Abbonamento ricorrente</Text>
            <Text fontSize="2xl" fontWeight="extrabold" color="indigo.600">€19,99</Text>
            <Button mt={6} colorScheme="indigo" as={Link} to="/login">Abbonati</Button>
          </Box>
          <Box bg={cardBg} p={8} borderRadius="xl" shadow="lg" textAlign="center">
            <Text fontWeight="bold" fontSize="lg" mb={2}>Annuale</Text>
            <Text fontSize="sm" color="gray.500" mb={4}>Risparmia di più</Text>
            <Text fontSize="2xl" fontWeight="extrabold" color="indigo.600">€199</Text>
            <Button mt={6} colorScheme="indigo" as={Link} to="/login">Abbonati</Button>
          </Box>
        </SimpleGrid>
      </Box>
{/* CTA finale */}
<Box py={20} textAlign="center" marginX="8">
  <Heading as="h2" size="lg" mb={4} color="indigo.700">
    Pronto a iniziare?
  </Heading>
  <Text fontSize="md" color="gray.600" mb={6}>
    Registrati ora e ottieni 100 crediti gratuiti.
  </Text>
  <Flex justify="center" gap={4}>
    <Button as={Link} to="/login" size="lg" colorScheme="indigo" px={8} py={6}>
      Registrati Gratis
    </Button>
    <Button as={Link} to="/login?mode=login" size="lg" variant="outline" colorScheme="indigo" px={8} py={6}>
      Hai già un account? Accedi
    </Button>
  </Flex>
</Box>

    </Box>
  );
};

export default Landing;
